import React from 'react';
import Hero from './Hero';
import ServicesSection from '../pages/ServicesSection';
import AboutsUs from '../pages/AboutsUs';
import { Client } from '../pages/Client';
import ContactForm from '../pages/ContactForm';
import OurSpecialties from '../pages/OurSpecialties';
import PopUpForm from '../pages/PopUpForm';


const Home = () => {
  return (
    <>
    <Hero />
    <AboutsUs />
    <OurSpecialties />
    <ServicesSection />
    <Client />
    <ContactForm /> 

    {/* <PopUpForm showOnLoad={true} /> */}
    </>
  );
};

export default Home;

